import { css } from '@emotion/react';
import { CHAT_HEIGHTS, HEADER_HEIGHT } from '@frontend/mini-chat-store';
import { theme } from '@frontend/theme';

export const miniChatContainerStyle = css({
  backgroundColor: theme.colors.white,
  boxShadow: theme.shadows.floating,
  borderTopLeftRadius: theme.borderRadius.medium,
  borderTopRightRadius: theme.borderRadius.medium,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
});

export const miniChatContentStyle = css({
  height: '100%',
  flexGrow: 1,
  display: 'flex',
  flexDirection: 'column',
});

export const miniChatBodyPlaceholderStyle = css({
  position: 'relative',
  maxHeight: CHAT_HEIGHTS['full'] - HEADER_HEIGHT,
  height: '100%',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
});

export const sendingAreaActionButtonsStyle = css({
  display: 'flex',
  alignItems: 'center',
  gap: 'var(--fabric-space-gap-xxs)',
  flex: '1 1 auto',
  minWidth: 0,
  marginRight: theme.spacing(1),
});

export const iconButtonBaseStyle = css({
  padding: 'var(--fabric-space-padding-xxs)',
  height: 'var(--fabric-number-n-6)',
  minHeight: 'unset',
  border: 'none',
  ':hover': {
    backgroundColor: theme.colors.neutral5,
  },
});

export const iconButtonDisabledStyle = css({
  cursor: 'default',
  border: 'none',
  ':hover': {
    backgroundColor: 'transparent',
  },
});

export const emojiButtonStyle = css({
  height: 'var(--fabric-number-n-6)',
  width: 'var(--fabric-number-n-6)',
  minWidth: 'unset',
  padding: 'var(--fabric-space-padding-xxs)',
});

export const templateButtonGroupBaseStyle = css({
  display: 'flex',
  height: 'var(--fabric-number-n-6)',
  borderRadius: 'var(--fabric-radius-sm)',
  overflow: 'hidden',
  flexShrink: 0,
});

export const templateButtonGroupHoverStyle = css({
  '&:hover': { background: 'var(--fabric-color-surface-inset-default)' },
});

export const templateButtonStyle = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  padding: 'var(--fabric-space-padding-none) var(--fabric-space-padding-xxs)',
});

export const templateQuickInsertButtonStyle = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  padding: 'var(--fabric-space-padding-none) var(--fabric-space-padding-xxs)',
});

export const templateButtonDisabledStyle = css({
  cursor: 'not-allowed',
});

export const templateButtonHoverStyle = css({
  '&:hover:not(:disabled)': { background: 'var(--fabric-color-neutral-20)' },
});

export const templateQuickInsertDividerStyle = css({
  display: 'flex',
  height: '100%',
  alignItems: 'center',
  justifyContent: 'center',
  boxShadow: 'inset 1px 0 0 var(--fabric-color-neutral-00)',
});

export const templateQuickInsertDividerHoverStyle = css({
  '&:hover': { background: 'var(--fabric-color-neutral-20)' },
});

export const templateCaretIconStyle = css({
  transition: 'transform 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
});

export const templateCaretIconOpenStyle = css({
  transform: 'rotate(180deg)',
});

export const styles = {
  emojiButtonStyle,
  iconButtonBaseStyle,
  iconButtonDisabledStyle,
  miniChatBodyPlaceholderStyle,
  miniChatContainerStyle,
  miniChatContentStyle,
  sendingAreaActionButtonsStyle,
  templateButtonDisabledStyle,
  templateButtonGroupBaseStyle,
  templateButtonGroupHoverStyle,
  templateButtonHoverStyle,
  templateButtonStyle,
  templateCaretIconOpenStyle,
  templateCaretIconStyle,
  templateQuickInsertButtonStyle,
  templateQuickInsertDividerHoverStyle,
  templateQuickInsertDividerStyle,
};
